import { type DocumentReference } from 'firebase/firestore';

import { DocumentCollectionType } from 'types/DocumentCollectionType';
import { DocumentType } from 'types/DocumentType';

import DocumentFolder, { type DocumentFolderParent } from './DocumentFolder';
import DocumentFolderCollection from './DocumentFolderCollection';
import { FolderPublicSchema, FolderSchema } from './DocumentFolderTypes';
import Project from './Project';

export default class Client extends DocumentFolder {
    schema = new FolderSchema();
    publicSchema = new FolderPublicSchema();
    type = DocumentType.CLIENT;
    collectionType = DocumentCollectionType.CLIENT;
    documents = new DocumentFolderCollection(this, Project);

    constructor(parent: DocumentFolderParent, docRef?: DocumentReference) {
        super(parent, docRef);
        this.becomeObservable();
    }
}
